import {
  ConversationColumnFilter,
  ConversationTagFilter,
  ConversationTableFilter
} from '../types/ConversationTableFilter';

/**
 * Namespaces a tag's chip id. Tag chips and column-filter chips share one bar
 * in TableV2, but are backed by different state — column filters replace by
 * filterId, tags accumulate — so removing a chip has to route by its id.
 */
const TAG_FILTER_ID_PREFIX = 'tags:';

/**
 * For the removal path, where TableV2 hands back a bare id rather than the
 * chip it came from. Prefer `isTagFilter` when the object is in hand.
 */
export const isTagFilterId = (filterId: string): boolean =>
  filterId.startsWith(TAG_FILTER_ID_PREFIX);

/** Narrows a chip to the tag half of the union, so `tag` is reachable. */
export const isTagFilter = (
  filter: ConversationTableFilter
): filter is ConversationTagFilter => isTagFilterId(filter.filterId);

/**
 * The complement. Needed as its own guard because negating `isTagFilter`
 * inside a callback does not narrow the other way.
 */
export const isColumnFilter = (
  filter: ConversationTableFilter
): filter is ConversationColumnFilter => !isTagFilterId(filter.filterId);

export const getTagFilterId = (tag: string): `tags:${string}` =>
  `${TAG_FILTER_ID_PREFIX}${tag}`;

/** One chip per tag, each removable on its own. */
export const buildTagFilters = (
  selectedTags: string[]
): ConversationTagFilter[] =>
  selectedTags.map((tag) => ({
    filterId: getTagFilterId(tag),
    tag,
    label: tag
  }));
